/** JWT `exp` is seconds since epoch; missing exp is treated as invalid (matches ProtectedRoute). */
export function isJwtExpired(decoded: { exp?: number } | null | undefined): boolean {
  const expiration = decoded?.exp;
  if (expiration == null) {
    return true;
  }
  return expiration < Date.now() / 1000;
}
